// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smallUnitDisplay{\n    border-radius: 8px;\n    width: 3rem;\n}", ""]);
// Exports
module.exports = exports;
